<template>
    <select-label
        v-model="ssl"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="sslEncryptions"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        item-text="text"
        item-value="value"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AppContext } from '../../store/context';
const SSLEncryptions = AppContext.SSLEncryptions;
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorSsl',
    components: {
        SelectLabel,
    },
})
export default class SelectorSsl extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.ssl = val;
    }
    @Watch('ssl', { immediate: true })
    onSSLChanged(val: string): void {
        this.$emit('input', val);
    }

    sslEncryptions = [];
    ssl = '';

    created() {
        this.sslEncryptions = SSLEncryptions.map(kv => {
            (kv as any).text = (this as any).$t(kv.text_key);
            return kv;
        });
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
}
</script>
